import { render } from "./cookie-modal.vue?vue&type=template&id=787d48aa&scoped=true"
import script from "./cookie-modal.vue?vue&type=script&lang=js"
export * from "./cookie-modal.vue?vue&type=script&lang=js"

import "./cookie-modal.vue?vue&type=style&index=0&id=787d48aa&scoped=true&lang=css"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787d48aa"]])

export default __exports__